import {
  DEFAULT_ANIMATE_DURATION,
  NextImage,
  noForwardProps
} from '@apeiron/temp'
import { Box, styled, Typography } from '@mui/material'
import ParagraphBlockLinkButton from '@src/components/battle/demo/blocks/ParagraphBlockLinkButton'
import ParagraphBlockView from '@src/components/battle/demo/blocks/ParagraphBlockView'
import { ImageAndParagraphsBlock, ParagraphBlock } from '@src/types/pageBuilder'

type ImageAndParagraphProps = {
  href?: string
  image: string
  title: string
  paragraphBlocks: ParagraphBlock[]
  layoutProps: ImageAndParagraphsBlock['layoutProps']
}

const Container = styled(Box)`
  display: flex;
  flex-direction: row;
  column-gap: 30px;

  ${props => props.theme.breakpoints.down('res768')} {
    flex-wrap: wrap;
    row-gap: 30px;
    justify-content: center;
  }
`

const TitleContainer = styled(Box)`
  display: flex;
  transition: transform ${DEFAULT_ANIMATE_DURATION}ms,
    filter ${DEFAULT_ANIMATE_DURATION}ms;

  ${props => props.theme.breakpoints.down('res768')} {
    justify-content: center;
  }

  :hover {
    filter: brightness(1.1);
    transform: translateY(-3px);
  }
`

const Title = styled(Typography)`
  background: #5c528d;
  border-radius: 4px;
  color: white;
  display: flex;
  font-size: 20px;
  line-height: 24px;
  font-weight: 400;
  padding: 2px 14px;
`

const RightBox = styled(Box)`
  display: flex;
  flex-direction: column;
  row-gap: 12px;
`

const Paragraphs = styled(Box, noForwardProps)<{ __spaceY: number }>`
  > * + * {
    margin-top: ${({ __spaceY }) => __spaceY}px;
  }
`

const ImageContainer = styled(Box)`
  transition: filter ${DEFAULT_ANIMATE_DURATION}ms,
    transform ${DEFAULT_ANIMATE_DURATION}ms;
  :hover {
    filter: brightness(1.1);
    transform: translateY(-3px);
  }
`

const StyledImage = styled(NextImage, noForwardProps)<{
  __aspectRatio: string
}>`
  aspect-ratio: ${({ __aspectRatio }) => __aspectRatio};
  width: 300px;
`

const ImageAndParagraphsBlockView = ({
  href,
  image,
  title,
  paragraphBlocks,
  layoutProps
}: ImageAndParagraphProps) => {
  return (
    <Container>
      <ImageContainer>
        <StyledImage
          src={image}
          alt={title}
          __aspectRatio={layoutProps.imageAspectRatio}
        />
      </ImageContainer>
      <RightBox>
        <TitleContainer>
          <Title>
            {title}
            <ParagraphBlockLinkButton href={href} />
          </Title>
        </TitleContainer>
        <Paragraphs __spaceY={layoutProps.paragraphSpaceY ?? 12}>
          {paragraphBlocks.map((paragraphBlock, index) => {
            const key = `${title}-${index}`

            return (
              <ParagraphBlockView
                key={key}
                href={paragraphBlock.href}
                text={paragraphBlock.value}
                layoutProps={paragraphBlock.layoutProps}
                variant={paragraphBlock.variant}
              />
            )
          })}
        </Paragraphs>
      </RightBox>
    </Container>
  )
}

export default ImageAndParagraphsBlockView
